// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { ICourseHttpResponse } from 'app_types/admin/course/courseTypes'
// @end

class CourseService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil
  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async list(params: any = {}) {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/courseCards`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }


  insertOrUpdate = async (postData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: ICourseHttpResponse
    const formData = new FormData()

    Object.keys(postData).map((key: string) => {
      if (typeof postData[key] === 'object' && !!postData[key][0]?.name && !!postData[key][0].type) {
        formData.append(key, postData[key][0])
      } else if (postData[key] instanceof Array) {
        formData.append(key, JSON.stringify(postData[key]))
      } else if (typeof postData[key] === 'object' && !(postData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(postData[key]))
      } else {
        formData.append(key, postData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/course/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.course
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  validateSlug = async (courseId: string, slug: string) => {
    this.refreshAuthToken()

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/course/validate-slug`,
      auth_token: this.token,
      params: { courseId, slug },
    }

    let responseData = await this.Http.send(queryData)

    return responseData
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: ICourseHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/course/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.course
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/course/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


}

export default CourseService
